/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'dns';

export const dnsModalBreadcrumbTitle = `${prefix}.dnsModalBreadcrumbTitle`;
export const dnsPolicyModalBreadcrumbTitle = `${prefix}.dnsPolicyModalBreadcrumbTitle`;
export const dnsRuleModalBreadcrumbTitle = `${prefix}.dnsRuleModalBreadcrumbTitle`;

export const ENGLISH = {
    [dnsModalBreadcrumbTitle]: 'DNS',
    [dnsPolicyModalBreadcrumbTitle]: 'DNS Policy',
    [dnsRuleModalBreadcrumbTitle]: 'DNS Rule',
};
